import Axios from 'axios';
var BasicArcheivesService = (function () {
    function BasicArcheivesService() {
    }
    BasicArcheivesService.prototype.getSupplierdepotList = function (params) {
        return Axios.get('supplierclientapi/supplierdepot/list', { params: params });
    };
    BasicArcheivesService.prototype.getOrganList = function () {
        return Axios.get('supplierclientapi/supplierorgan/get_options');
    };
    BasicArcheivesService.prototype.addStore = function (params) {
        return Axios.post('supplierclientapi/supplierdepot/create', params);
    };
    BasicArcheivesService.prototype.updateStore = function (params) {
        return Axios.post('supplierclientapi/supplierdepot/update', params);
    };
    BasicArcheivesService.prototype.getPinyin = function (params) {
        return Axios.get('basicapi/getpinyin', { params: params });
    };
    BasicArcheivesService.prototype.changeStoreStatus = function (params) {
        return Axios.get('supplierclientapi/supplierdepot/change', { params: params });
    };
    BasicArcheivesService.prototype.changeDefaultStore = function (params) {
        return Axios.get('supplierclientapi/supplierdepot/default', { params: params });
    };
    BasicArcheivesService.prototype.getSupplyGoods = function (params) {
        return Axios.get('supplierclientapi/customer/goods_list', { params: params });
    };
    BasicArcheivesService.prototype.getSupplierShops = function (params) {
        return Axios.get('supplierclientapi/customer/shop_list', { params: params });
    };
    BasicArcheivesService.prototype.editSupplierShop = function (params) {
        return Axios.post('supplierclientapi/shop/shop_save', params);
    };
    BasicArcheivesService.prototype.getGroups = function (params) {
        return Axios.get('supplierclientapi/customer/group_list', { params: params });
    };
    BasicArcheivesService.prototype.addGroup = function (params) {
        return Axios.post('supplierclientapi/customer/save_group', params);
    };
    BasicArcheivesService.prototype.delGroups = function (params) {
        return Axios.post('supplierclientapi/customer/group_del', params);
    };
    BasicArcheivesService.prototype.getClientGoods = function (params) {
        return Axios.get('supplierclientapi/suppliergoods/bussiness_goods_list', { params: params });
    };
    BasicArcheivesService.prototype.getClientsByGroup = function (params) {
        return Axios.get('supplierclientapi/customer/group_childs', { params: params });
    };
    BasicArcheivesService.prototype.bindGoods = function (params) {
        return Axios.post('supplierclientapi/suppliergoods/do_bind', params);
    };
    BasicArcheivesService.prototype.unbindGoods = function (params) {
        return Axios.post('supplierclientapi/suppliergoods/un_bind', params);
    };
    BasicArcheivesService.prototype.changeGroup = function (params) {
        return Axios.post('supplierclientapi/customer/change_group', params);
    };
    BasicArcheivesService.prototype.getGoodType = function (params) {
        return Axios.get('http://api.scmacewill.cn:3000/apimock/getMockData?id=97', { params: params });
    };
    BasicArcheivesService.prototype.addCheck = function () {
        return Axios.get('supplierclientapi/customer/add_check');
    };
    BasicArcheivesService.prototype.getGoodsPriceList = function (params) {
        return Axios.get('supplierclientapi/supplieruppergoodsprice/list', { params: params });
    };
    BasicArcheivesService.prototype.getSupplierupperCategoryList = function (params) {
        return Axios.get('supplierclientapi/supplierupper/category_list', { params: params });
    };
    BasicArcheivesService.prototype.setSupplierupperGoodsPrice = function (params) {
        return Axios.post('supplierclientapi/supplieruppergoodsprice/set', params);
    };
    BasicArcheivesService.prototype.batchSetSupplierupperGoodsPrice = function (params) {
        return Axios.post('supplierclientapi/supplieruppergoodsprice/batch_set', params);
    };
    BasicArcheivesService.prototype.supplierupperSaveGoods = function (params) {
        return Axios.post('supplierclientapi/supplieruppergoods/save_goods', params);
    };
    BasicArcheivesService.prototype.getStockinitGoodslist = function (params) {
        return Axios.post('supplierclientapi/supplieruppergoods/goodspricelist', params);
    };
    BasicArcheivesService.prototype.supplierupperGoodsDelete = function (params) {
        return Axios.post('supplierclientapi/supplieruppergoodsprice/delete', params);
    };
    BasicArcheivesService.prototype.supplierupperCopy = function (params) {
        return Axios.get('supplierclientapi/supplieruppergoodsprice/copy', { params: params });
    };
    BasicArcheivesService.prototype.delStoreSplit = function (params) {
        return Axios.post('supplierclientapi/depotsortingrule/delete', params);
    };
    BasicArcheivesService.prototype.changeStoreSplitStatus = function (params) {
        return Axios.post('supplierclientapi/depotsortingrule/change', params);
    };
    BasicArcheivesService.prototype.delSpotPurchaseRule = function (params) {
        return Axios.post('supplierclientapi/upper_warehouse_order_rule/delete', params);
    };
    BasicArcheivesService.prototype.getStoreSplitList = function (params) {
        return Axios.get('supplierclientapi/depotsortingrule/list', { params: params });
    };
    BasicArcheivesService.prototype.getSpotPurchaseRuleList = function (params) {
        return Axios.get('supplierclientapi/upper_warehouse_order_rule/list', { params: params });
    };
    BasicArcheivesService.prototype.addStoreSplit = function (params) {
        return Axios.post('supplierclientapi/depotsortingrule/create', params);
    };
    BasicArcheivesService.prototype.addStoreSpotPurchase = function (params) {
        return Axios.post('supplierclientapi/upper_warehouse_order_rule/create', params);
    };
    BasicArcheivesService.prototype.updateStoreSpotPurchase = function (params) {
        return Axios.post('supplierclientapi/upper_warehouse_order_rule/update', params);
    };
    BasicArcheivesService.prototype.updateStoreSplit = function (params) {
        return Axios.post('supplierclientapi/depotsortingrule/update', params);
    };
    BasicArcheivesService.prototype.getGoodsType = function (params) {
        return Axios.get('supplierclientapi/suppliergoodstype/type_list', { params: params });
    };
    BasicArcheivesService.prototype.getStoreSplitDetail = function (params) {
        return Axios.get('supplierclientapi/depotsortingrule/detail', { params: params });
    };
    BasicArcheivesService.prototype.getStoreSplitFilterData = function (params) {
        return Axios.get('supplierclientapi/depotsortingrule/get_filter_data', { params: params });
    };
    BasicArcheivesService.prototype.getSpotPurchaseRuleDetail = function (params) {
        return Axios.get('supplierclientapi/upper_warehouse_order_rule/detail', { params: params });
    };
    BasicArcheivesService.prototype.getDepotId = function (params) {
        return Axios.get('supplierclientapi/depotsortingrule/get_depot_id', { params: params });
    };
    BasicArcheivesService.createInstance = function () {
        BasicArcheivesService.getInstance();
    };
    BasicArcheivesService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return BasicArcheivesService;
}());
export default BasicArcheivesService;
